/* ========== Custom Scripts for Product Page Only ========== */
/* ========== Added by Yogi @ 2025-06-28 ========== */

/* ====================== Smart Visitor Count Bar  ====================== */
/* ----------- Liquid : mj_smart-visitor-count || Added @ 2025-06-28  --------- */
(function () {
  var now = new Date();
  var hour = now.getHours();
  var min, max;
  if (hour >= 0 && hour <= 6) {
    // Night
    min = 30;
    max = 60;
  } else if (hour >= 7 && hour <= 10) {
    // Morning
    min = 60;
    max = 90;
  } else if (hour >= 11 && hour <= 16) {
    // Midday/Peak
    min = 90;
    max = 120;
  } else if (hour >= 17 && hour <= 21) {
    // Evening
    min = 70;
    max = 110;
  } else {
    // Late Night (22-23)
    min = 40;
    max = 70;
  }
  var count = Math.floor(Math.random() * (max - min + 1)) + min;
  var el = document.getElementById("mj-custom-visitors-count-number");
  if (el) {
    el.textContent = count;
  }
})();

/* ====================== Floating Payment Button Bar  ====================== */
/* ----------- Liquid :  || Added @ 2025-07-08  --------- */
(function () {
  var floatingBar = document.getElementById("mj-btn-row-floating");
  var mainBtnRow = document.getElementById("mj-btn-row-main");
  // var mainBtnRow = document.querySelector(".mj-btn-row");
  /* var header = document.getElementsByClassName(
    "shopify-section-group-header-group shopify-section--header"
  );
*/
  var header = document.getElementById('shopify-section-sections--19146784604387__header');
  // var header = document.getElementsByClassName('shopify-section-group-header-group shopify-section--header');
  function isMobile() {
    return window.innerWidth <= 749;
  }

  function updateHeaderHeight() {
    if (header) {
      document.documentElement.style.setProperty(
        "--header-height",
        header.clientHeight + "px"
      );
    }
  }

  function updateFloatingBar(position) {
  
    if (!isMobile() || !mainBtnRow || !floatingBar) {
      floatingBar.style.display = "none";
      return;
    }
    if (position === "in") {
      //console.log(position);
      floatingBar.style.display = "none";
      floatingBar.classList.remove("top", "bottom");
    } else if (position === "above") {
      //console.log(position);
      floatingBar.style.display = "block";
      floatingBar.classList.add("top");
      floatingBar.classList.remove("bottom");
    } else if (position === "below") {
      //console.log(position);
      floatingBar.style.display = "block";
      floatingBar.classList.add("bottom");
      floatingBar.classList.remove("top");
    }
  }

  function checkPosition() {
    floatingBar = document.getElementById("mj-btn-row-floating");
    //var mainBtnRow = document.querySelector(".mj-btn-row");
    mainBtnRow = document.getElementById("mj-btn-row-main");

    
    if (!mainBtnRow) return;
    var rect = mainBtnRow.getBoundingClientRect();
    var headerHeight = header ? header.clientHeight : 56;

    if (rect.top <= headerHeight + 8) {
      updateFloatingBar("above");
    } else if (rect.bottom >= window.innerHeight - 8) {
      updateFloatingBar("below");
    } else {
      updateFloatingBar("in");
    }
  }

  window.addEventListener("scroll", checkPosition);
  window.addEventListener("resize", function () {
    updateHeaderHeight();
    checkPosition();
  });

  document.addEventListener("DOMContentLoaded", function () {
    updateHeaderHeight();
    checkPosition();
    // Button triggers
    var addToCartFloating = document.getElementById("AddToCartFloating");
    var addToCartMain = document.getElementById("AddToCart");
    if (addToCartFloating && addToCartMain) {
      addToCartFloating.addEventListener("click", function (e) {
        e.preventDefault();
        addToCartMain.click();
      });
    }
    var buyNowFloating = document.getElementById("gokwik-buy-now-floating");
    var buyNowMain = document.getElementById("gokwik-buy-now");
    if (buyNowFloating && buyNowMain) {
      buyNowFloating.addEventListener("click", function (e) {
        e.preventDefault();
        buyNowMain.click();
      });
    }
  });
  
 
  // Observe changes to the product form container
  var productFormContainer = document.querySelector('.product-form');
  if (!productFormContainer) return;

  // Create a MutationObserver to watch for changes in the product form
  var observer = new MutationObserver(function(mutationsList) {
    for (var mutation of mutationsList) {
      // If nodes were added, check if .mj-btn-row is present
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        var mainBtnRow = document.querySelector('.mj-btn-row');
        if (mainBtnRow) {
          // Wait for layout, then update floating bar
          requestAnimationFrame(function() {
            if (typeof checkPosition === 'function') {
              checkPosition();
            }
          });
        }
      }
    }
  });

  // Start observing for child list changes (DOM additions/removals)
  observer.observe(productFormContainer, { childList: true, subtree: true });

  // Also, run checkPosition on initial load
  if (typeof checkPosition === 'function') {
    checkPosition();
  }
})();

// /* ====================== Pdt Gallery Placement for Mobile  ====================== */
// /* ----------- Liquid :  || Added @ 2025-07-08  --------- */
//   document.addEventListener("DOMContentLoaded", function () {
//     const desktopPlaceholder = document.getElementById("mj-gallery-placeholder-desktop");
//     const mobilePlaceholder = document.getElementById("mj-gallery-placeholder-mobile");

//     let gallery = desktopPlaceholder?.firstElementChild;

//     if (!gallery || !desktopPlaceholder || !mobilePlaceholder) {
//       console.warn("Gallery or placeholders not found.");
//       return;
//     }

//     function reinitializeGallery() {
//       // Focal theme init
//       if (typeof theme !== "undefined" && typeof theme.initProductMedia === "function") {
//         theme.initProductMedia();
//       }

//       // Flickity re-init if needed manually (usually handled above)
//       const carousels = document.querySelectorAll("[data-flickity-config]");
//       carousels.forEach((el) => {
//         if (!el.classList.contains("flickity-enabled")) {
//           // flickity should already be available globally
//           new Flickity(el, JSON.parse(el.getAttribute("data-flickity-config")));
//         }
//       });
//     }

//     function moveGallery() {
//       const isMobile = window.innerWidth < 990;

//       if (isMobile && !mobilePlaceholder.contains(gallery)) {
//         mobilePlaceholder.appendChild(gallery);
//         reinitializeGallery();
//       } else if (!isMobile && !desktopPlaceholder.contains(gallery)) {
//         desktopPlaceholder.appendChild(gallery);
//         reinitializeGallery();
//       }
//     }

//     moveGallery();

//     // Resize listener with debounce for performance
//     let resizeTimeout;
//     window.addEventListener("resize", function () {
//       clearTimeout(resizeTimeout);
//       resizeTimeout = setTimeout(moveGallery, 200);
//     });
//   });



  // document.addEventListener('DOMContentLoaded', () => {
  //   const moveGallery = () => {
  //     const productContainer = document.querySelector('.product');
  //     const gallery = document.querySelector('.product__media');
  //     const info = document.querySelector('.product-meta');
  //     const flickityCarousel = gallery.querySelector('flickity-carousel');


  //   const desktopPlaceholder = document.getElementById("mj-gallery-placeholder-desktop");
  //   const mobilePlaceholder = document.getElementById("mj-gallery-placeholder-mobile");


  //     if (!productContainer || !gallery || !info || !flickityCarousel) {
  //       // If elements are not found, ensure gallery is visible to avoid it being permanently hidden
  //       if(gallery) gallery.style.opacity = 1;
  //       return;
  //     }

  //     const isMobile = window.innerWidth <= 740;
  //     const galleryIsAfterInfo = info.nextElementSibling === gallery;
  //     const galleryIsFirst = productContainer.firstElementChild === gallery;

  //     if (isMobile && !galleryIsAfterInfo) {
  //       info.insertAdjacentElement('afterend', gallery);
  //       if (flickityCarousel.flickityInstance) {
  //         flickityCarousel.reload();
  //       }
  //     } else if (!isMobile && !galleryIsFirst) {
  //       productContainer.prepend(gallery);
  //       if (flickityCarousel.flickityInstance) {
  //         flickityCarousel.reload();
  //       }
  //     }
  //     gallery.style.opacity = 1;
  //   };

  //   // Initial check
  //   moveGallery();

  //   // Re-check on window resize
  //   let resizeTimer;
  //   window.addEventListener('resize', () => {
  //     clearTimeout(resizeTimer);
  //     resizeTimer = setTimeout(() => {
  //       moveGallery();
  //     }, 250);
  //   });
  // });


